import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popover as ReactstrapPopover } from 'reactstrap';

function Popover(props) {
  return (
    <ReactstrapPopover className={props.className} {...props}>
      {props.children}
    </ReactstrapPopover>
  );
}

Popover.propTypes = {
  className: PropTypes.string
};

const StyledPopover = styled(Popover)`
  .popover {
    background: ${props => (props.className === 'errors' ? '#ff7171' : '#f00')};
    border-color: ${props =>
      props.className === 'errors' ? '#ff7171' : props.theme.colors.grey};
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  }

  border-color: ${props =>
    props.className === 'errors'
      ? 'rgba(255, 0, 0, 0.75)'
      : 'rgba(0, 0, 0, 0.2)'};

  .popover-body {
    color: ${props => (props.className === 'errors' ? '#fff' : '#000')};
  }

  .arrow::before {
    border-top-color: ${props =>
      props.className === 'errors'
        ? 'rgba(255, 0, 0, 0.75)'
        : 'rgba(0, 0, 0, 0.2)'};
  }

  .arrow::after {
    border-top-color: ${props =>
      props.className === 'errors' ? '#ff7171' : '#f00'};
  }

  .close:hover {
    background-color: transparent;
    color: #fff;
  }
`;

export default StyledPopover;
